import { render, staticRenderFns } from "./stories_detail.vue?vue&type=template&id=02a65d86&"
import script from "./stories_detail.vue?vue&type=script&lang=js&"
export * from "./stories_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports